import React from 'react';
import { BsFolder2Open } from 'react-icons/bs';
import { RiCloseLine } from 'react-icons/ri';
import { Button } from 'reactstrap';

const EditUploadDownloadWrapper = ({
  fileName = '',
  //   label = '',
  handleCancel = () => {},
  handleDownload = () => {},
  // title = '',
  //   required = false,
}) => {
  return (
    <div className="edit-upload-wrap vendor mb-3 position-relative">
      <BsFolder2Open
        color="#666"
        size={24}
        className="file-icon position-absolute top-50 translate-middle"
      />
      <Button
        className="f-12 fw-medium p-0 ms-1 file-name text-decoration-none text-start"
        color="link"
        onClick={handleDownload}
        title={fileName}
      >
        {fileName}
      </Button>
      <Button
        color="link"
        onClick={handleCancel}
        className="text-decoration-none p-0 text-dark-525 cancel-btn position-absolute top-50 translate-middle"
      >
        <RiCloseLine size={22} />
      </Button>
    </div>
  );
};

export default EditUploadDownloadWrapper;
